import { render } from "./Twitter.vue?vue&type=template&id=efef7a5e"
const script = {}
script.render = render

export default script